import { registerPlugin } from '@capacitor/core';
const HeadsetPlugin = registerPlugin('HeadsetPlugin', {
    web: () => import('./web').then(m => new m.HeadsetPluginWeb()),
});
export * from './definitions';
export { HeadsetPlugin };
//# sourceMappingURL=index.js.map